import { render, staticRenderFns } from "./serve-num.vue?vue&type=template&id=8597125c&scoped=true&"
import script from "./serve-num.vue?vue&type=script&lang=js&"
export * from "./serve-num.vue?vue&type=script&lang=js&"
import style0 from "./serve-num.vue?vue&type=style&index=0&id=8597125c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8597125c",
  null
  
)

export default component.exports